export const addToCalModal = {
    TITLE: 'Add Event to Calendar',
    SUB_TITLE: 'Events may appear as all day events on your calendar.',
};

export const calendarUrls = {
    GOOGLE: 'https://calendar.google.com/calendar/render',
    OUTLOOK: 'https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent',
};

export const eventFeedForTrackCalls = {
    TOP_FUNNEL: 'Add to Calendar Post Registration',
    MID_FUNNEL_A: 'Add to Calendar Event Page',
    MID_FUNNEL_B: 'Add to Calendar Home Feed',
    END_FUNNEL: 'Add to Calendar Completed',
};
